export const NEXT = 'next';
export const PREVIOUS = 'previous';
